// extracted by mini-css-extract-plugin
export default {"container":"arh2qf","header":"cJscj1","content":"cTdFFO","controls":"wdbmEY","isLayoutTextOnImage":"nAaNon"};